import { HandleErrorInterceptor } from './core/Interceptors/handle-error-interceptor';
import { HeadersInterceptor } from './core/Interceptors/headers-interceptor.service';
import { RuleEngineAuthInterceptor } from './core/Interceptors/rule-engine-auth.interceptor';
import { UcontrolAuthInterceptor } from './core/Interceptors/ucontrol-auth.interceptor';
import { CoreModule } from './core/core.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { initializeApp } from './core/initializers/app-initializer';
import { DataService } from './core/services/data.service';
import { ApiService } from './core/services/api.service';
import { ConfigurationsService } from './core/services/configurations.service';
import { StateInitializerService } from './core/services/state-initializer.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { TemplatePageComponent } from './template-page/template-page.component';
import { SharedModule } from './shared/shared.module';
import { TokenInterceptor } from './core/Interceptors/token-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { AuthService } from './core/services/auth.service';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { environment } from 'src/environments/environment';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeDe from '@angular/common/locales/de';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import { StoreModule } from '@ngrx/store';
import { reducerCompleteApplyState, reducerDashboardData, reducerDashboards, reducerFilterRefSetting, reducerSetTabAssetChooserRef, reducerTrailersOfCustomers, reducersApplySelectedAssets, reducersApplySelectedCustomer, reducersApplySelectedPeriod, reducersCustomers, reducersDriversOfCustomers, reducersIotAssets, reducersSelectedCustomerCache, reducersSetSelectedAssets, reducersSetSelectedPeriod, reducersSetTabFilterRef, reducersUser, reducersVehiclesOfCustomers, reducerVehicleFilters } from './core/store/reducers';
import { metaReducers } from './core/store/hydration';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { PostEffects } from './core/store/effects';
import { HydrationEffects } from './core/store/hydration/hydration.effects';
import { confGlobalReducer } from './core/store/globalConfig/conf-global.reducer';
import { IotAssetEffects } from './core/store/iotAssets/iotAsset.effects';
import { catalogReducer } from './core/store/catalog/catalog.reducer';
import { CatalogEffects } from './core/store/catalog/catalog.effects';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeDe);
registerLocaleData(localePt);
registerLocaleData(localeEs);

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.baseUrl
  },
  palette: {
    popup: {
      background: "#7bac41"
    },
    button: {
      background: "white",
      text: "gray"
    }
  },
  theme: "classic",
  layout: 'my-custom-layout',
  layouts: {
    "my-custom-layout": '{{messagelink}}{{compliance}}'
  },
  elements: {
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a  class="cc-link" id="cookieconsent-link" >{{link}}</a>
    </span>
    `,
  }
};
@NgModule({
  declarations: [
    AppComponent,
    TemplatePageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LeafletModule,
    LeafletDrawModule,
    LeafletMarkerClusterModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    NgcCookieConsentModule.forRoot(cookieConfig),


    //StoreModule.forRoot({}, {}),

    StoreModule.forRoot(
      {
        'getCustomers':reducersCustomers,
        'getVehiclesOfCustomers':reducersVehiclesOfCustomers,
        'iotAssets': reducersIotAssets,
        'getTrailersOfCustomers' : reducerTrailersOfCustomers,
      // 'getFleetsOfCustomers':reducersFleetsOfCustomers,
        'getDriversOfCustomers':reducersDriversOfCustomers,
      // 'getTeamsOfCustomers':reducersTeamsOfCustomers,
        'setSelectedCustomerCache':reducersSelectedCustomerCache,
        'setTabFilterRef':reducersSetTabFilterRef,
        'setTabAssetChooserRef':reducerSetTabAssetChooserRef,
        'user':reducersUser,
        'applySelectedCustomer':reducersApplySelectedCustomer,
        'setSelectedAssets':reducersSetSelectedAssets,
        'applySelectedAssets':reducersApplySelectedAssets,
        'setSelectedPeriod':reducersSetSelectedPeriod,
        'applySelectedPeriod':reducersApplySelectedPeriod,
        'completeApplyState':reducerCompleteApplyState,
        'filterRefSetting':reducerFilterRefSetting,
        'vehicleFilters':reducerVehicleFilters,
        'dashboards': reducerDashboards,
        'dashboardData': reducerDashboardData,
        'catalog': catalogReducer
      },
      { metaReducers }),
     EffectsModule.forRoot([PostEffects, HydrationEffects, IotAssetEffects, CatalogEffects]),
     StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [DataService, ApiService, ConfigurationsService, StateInitializerService],
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: RuleEngineAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UcontrolAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
        provide: HTTP_INTERCEPTORS,
        useFactory: function(authService: AuthService) {
          return new HandleErrorInterceptor(authService);
        },
        multi: true,
        deps: [AuthService]
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
